import type { PurchaseHistory } from '../modules/DataTransformSchema';
import { getOrderDate } from './index';

export function hasUsableProductImage(order: PurchaseHistory) {
  const image = order.product_image;
  if (!image || image === 'N/A') return false;
  return (
    image.startsWith('http://') ||
    image.startsWith('https://') ||
    image.startsWith('/')
  );
}

export function getProductInitial(productName: string) {
  return productName.trim().charAt(0).toUpperCase() || '?';
}

export function formatOrderDate(order: PurchaseHistory) {
  const date = getOrderDate(order);
  if (!date) return '';
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
}
